module.exports = __webpack_public_path__ + "media/images/credit-card-empty-3eee254fe8a8d7a9ba6524a3cfe11684.png";